import fetchHandler from '../../tools/tracking/fetchHandler'
import { firebaseDomain } from '../domain'
import { setUserSessionIdCookie, eraseUserSessionIdCookie } from './cookieOperations'
import handleLoginPortalRedirect from './handleLoginPortalRedirect'

const generateSessionIdWithTokenId = async (idToken) => {
  try {
    // POST with token in body (fixes HTTP 431 error caused by long tokens in URL)
    // Uses standalone authTokenExchange function at /auth/token-exchange
    const resp = await fetchHandler(`${firebaseDomain.replace('/api', '/auth')}/token-exchange`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ idToken }),
    })

    if (resp.status === 200) {
      const message = (await resp.json()).message
      setUserSessionIdCookie(message)
      return message
    }
  } catch (err) {
    console.log(err)
    eraseUserSessionIdCookie()
  }
}

var generatingToken = false
const handleGenerateSessionIdWithTokenId = async (idToken) => {
  if (generatingToken) {
    return
  }
  generatingToken = true
  const generateSessionIdWithTokenIdSuccess = await generateSessionIdWithTokenId(idToken)
  generatingToken = false

  if (!generateSessionIdWithTokenIdSuccess) {
    return true
  }

  handleLoginPortalRedirect()
  return
}

export default handleGenerateSessionIdWithTokenId